export default "<p>dashboard works!</p>\r\n"